<div class="modal-container-content">
  <div>{{ product.specs.description }}</div>
  @if (product.id === 10) {
    <div class="caution">
      <app-icon icon="warning"/>
      <span>Let op: Als je ESPN in je abonnement hebt schakelen we dit bij het bestellen van het Familiepakket uit.
      ESPN is namelijk onderdeel van het Familiepakket, en we willen voorkomen dat je dubbele kosten krijgt.</span>
    </div>
  }
  <app-divider/>
  @if (product.discounted_price) {
    <app-product-price-display [product]="product"/>
  }
  <app-currency [value]="product.price" [monthly]="true" size="large" [emphasis]="true"/>
</div>

<div class="modal-container-footer">
  <app-button [disabled]="isLoading" (click)="order()" type="primary">Bestellen</app-button>
  <app-button (click)="modalRef.cancel()" onkeyup="modalRef.cancel()" type="outline">Annuleren</app-button>
</div>
